import { UserRoles } from "@/types";
import featureConfig from "@/helpers/featureConfigs";
import { objectify } from ".";

export function getGroupAccess(groups: string[] = []) {
  const dataAccess: any = {};
  const featureAccess: any = {};
  let callConfigs;

  for (const group of featureConfig.getGroups(groups)) {
    const permissions = objectify(group.groupPolicy).permissions || [];
    callConfigs = group.callConfigs || {};

    for (const permission of permissions) {
      let access: string[] = permission.split(":");
      if (access.length == 3) {
        if (dataAccess[access[0]]) {
          dataAccess[access[0]][access[2]] = access[1];
        } else {
          dataAccess[access[0]] = {
            [access[2]]: access[1]
          };
        }
      } else {
        featureAccess[access[0]] = true;
      }
    }
  }
  return { dataAccess, featureAccess, callConfigs };
}

export function checkFeatureAccess(
  feature: string,
  { roles, access }: { roles: UserRoles; access: any }
) {
  if (roles.includes("admin")) {
    return true;
  }
  return !!access.featureAccess[feature];
}

export function checkDataAccess(
  resource: string,
  { roles, access }: { roles: UserRoles; access: any }
) {}
